import { FC, Fragment } from "react";
import { Link } from "react-router-dom";
import "./breadcrumbs.scss";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface Props {
  items: BreadcrumbItem[];
  productName?: string;
  productId?: number;
}
const BreadcrumbsItem: FC<Props> = ({ items, productName, productId }) => {
  if (!items?.length) return null;

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ul className="breadcrumbs__list">
        {items.map((item, index) => {
          const hasProduct = Boolean(productName);
          const isLast = !hasProduct && index === items.length - 1;
          const isBeforeProduct = hasProduct && index === items.length - 1;

          return (
            <Fragment key={`${item.label}-${index}`}>
              <li
                className={`breadcrumbs__item ${
                  isLast || isBeforeProduct ? "breadcrumbs__item--active" : ""
                }`}
              >
                {!isLast && !isBeforeProduct && item.to ? (
                  <Link className="breadcrumbs__link" to={item.to}>
                    {item.label}
                  </Link>
                ) : isBeforeProduct ? (
                  <Link
                    className="breadcrumbs__link"
                    to={`/products/${productId}`}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="breadcrumbs__text ">{item.label}</span>
                )}
              </li>

              {!isLast && !isBeforeProduct && (
                <li className="breadcrumbs__separator">/</li>
              )}
              {isBeforeProduct && <li className="breadcrumbs__separator">/</li>}
            </Fragment>
          );
        })}

        {productName && (
          <>
            <li className="breadcrumbs__item breadcrumbs__item--active breadcrumbs__text-last">
              <span className="breadcrumbs__text">{productName}</span>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default BreadcrumbsItem;
